import { IRowNode } from 'ag-grid-community';
import { AssetTreeNode } from '../../model/asset-tree-node.model';

export function expandWithParents(rowNode: IRowNode<AssetTreeNode>) {
  let node: IRowNode<AssetTreeNode> | null = rowNode;

  // Expand node with all its parent nodes.
  while (node) {
    node.setExpanded(true);
    node = node.parent;
  }
}
